var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7107 2.2253C13.0111 2.52571 13.0111 3.01276 12.7107 3.31316L4.02384 12L12.7107 20.6868C13.0111 20.9872 13.0111 21.4743 12.7107 21.7747C12.4103 22.0751 11.9232 22.0751 11.6228 21.7747L2.39205 12.5439C2.09165 12.2435 2.09165 11.7565 2.39205 11.4561L11.6228 2.2253C11.9232 1.9249 12.4103 1.9249 12.7107 2.2253Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8645 2.2253C19.1649 2.52571 19.1649 3.01276 18.8645 3.31316L10.1777 12L18.8645 20.6868C19.1649 20.9872 19.1649 21.4743 18.8645 21.7747C18.5641 22.0751 18.0771 22.0751 17.7767 21.7747L8.5459 12.5439C8.24549 12.2435 8.24549 11.7565 8.5459 11.4561L17.7767 2.2253C18.0771 1.9249 18.5641 1.9249 18.8645 2.2253Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPage);
export default __webpack_public_path__ + "static/media/first_page.96579138145e35b706e40fd13bd75de6.svg";
export { ForwardRef as ReactComponent };